import React from 'react'

const Contact = () => {
  return (
    <div className='container my-5' style={{background:'rgb(245, 241, 236)'}}>
        <h1 className='text-center my-5 p-5'>CONTACT US</h1>
        <div className='container'>
            <div className='row'>
                <div className='col-md-6 col-sm-12'>
                    <img src='ContactImg.webp' alt='' style={{width:'100%',height:'70%'}}></img>
                </div>
                <div className='col-md-6 col-sm-12'>
                    <h4 className='text-center mt-5'>Clients and Alliances</h4>
                    <p>Every company has different IT needs. However, the specific needs of your company are unique. Send us a message, and we’ll help you find the services that best fit your requirements. We’re just an email away and ready to partner with you. Reach us @ <a href=''>info@arhsys.com</a> </p>
                    <p>Contact Us : 925-997-6179</p>
                    <p>Address : 6210 Stoneridge Mall Rd Pleasanton Corporate Commons</p>
                    <p>Pleasanton, CA 94588</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact